import { useForm } from "@inertiajs/react";
import { Input } from "@/components/ui/input.jsx";
import { Button } from "@/components/ui/button.jsx";
import { Heading } from "@/components/ui/heading.jsx";
import { contact_request_path } from "@/routes.js";
import { Loader } from "lucide-react";
import { Textarea } from "@/components/ui/textarea.jsx";
import { useState } from "react";

function validatePhone(phone) {
  const digits = phone.replace(/\D/g, "");
  if (!digits) return "Введите номер телефона";
  if (digits.length === 11 && (digits[0] === "7" || digits[0] === "8")) return null;
  if (digits.length === 10) return null;
  return "Введите корректный номер телефона";
}

export default function () {
  const { data, setData, post, processing, errors, reset, wasSuccessful } =
    useForm({
      phone: "",
      name: "",
      message: "",
    });

  const [localErrors, setLocalErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneError = validatePhone(data.phone);
    if (phoneError) {
      setLocalErrors({ phone: phoneError });
      return;
    }
    setLocalErrors({});

    await post(contact_request_path(), data);
    reset();
  };

  const handleChange = (e) => {
    setData(e.target.name, e.target.value);
    if (localErrors[e.target.name]) {
      setLocalErrors((prev) => ({ ...prev, [e.target.name]: null }));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid gap-4">
        <div className="">
          <Input
            name="phone"
            size="xl"
            className="w-full"
            placeholder="Телефон"
            value={data.phone}
            onChange={handleChange}
          />
          {(localErrors.phone || errors?.phone) && (
            <p className="text-red-500 text-sm mt-1">
              {localErrors.phone || errors.phone}
            </p>
          )}
        </div>
        <Button size="xl" disabled={processing}>
          {processing && <Loader className="size-6" />} Перезвоните мне
        </Button>
      </div>
    </form>
  );
}
